import { server_connection } from './../../../../../config';
import { getEvents } from './calendar.actions';
import store from 'store';
import { getLessonList } from '../../../lesson/store/actions';

export const GET_COMPANY_LIST = '[COMPANY APP] GET COMPANY LIST';
export const GET_COMPANY = '[COMPANY APP] GET COMPANY';
export const GET_COMPANY_DATA = '[COMPANY APP] GET COMPANY DATA';
export const GET_RELATED_DATA = '[COMPANY APP] GET RELATED DATA';
export const UPDATE_COMPANY_LOADED = '[COMPANY APP] UPDATE COMPANY LOADED';
export const DELETE_COMPANY = '[COMPANY APP] DELETE COMPANY';
export const SAVE_COMPANY = '[COMPANY APP] SAVE COMPANY';
export const UPDATE_COMPANY_FORM = '[COMPANY APP] UPDATE COMPANY FORM';
export const GET_COMPANY_AUTH_LIST = '[COMPANY APP] GET COMPANY AUTH';
// COMPANY -> instructor 
export const TOGGLE_INSTRUCTOR = '[COMPANY APP] TOGGLE INSTRUCTOR';
//COMPANY -> Major
export const GET_ALL_MAJORS = '[COMPANY APP] GET ALL MAJORS';
export const TOGGLE_MAJOR = '[COMPANY APP] TOGGLE MAJOR';

export const GET_ALL_COURSES = '[COMPANY APP] GET ALL COURSES';
export const GET_ALL_MODULES = '[COMPANY APP] GET ALL MODULES';
export const GET_ALL_LESSONS = '[COMPANY APP] GET ALL LESSONS';

export const GET_SCHEDULED_COURSES = '[COMPANY APP] GET SCHEDULED COURSES';

export function updateCompanyLoaded(setting) {
    return {
        type: UPDATE_COMPANY_LOADED,
        payload: setting
    }
}

export function updateCompanyForm(company_data) {
    return {
        type: UPDATE_COMPANY_FORM,
        payload: company_data
    }
}

export function saveCompany(company, instructor_list, major_list) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/company/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    company: company,
                    instructor_list: instructor_list,
                    major_list: major_list,

                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getCompanyList());
            });

    }
}


export function getCompany(company_id) {
    return (dispatch, getState) => {
        return fetch(server_connection + '/company/get/' + company_id)
            .then((response) => response.json())
            .then((companyData) => {
                return dispatch({
                    type: GET_COMPANY,
                    payload: companyData,
                });
            });
    }
}

export function getScheduledCourses(company_id, dropDate) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/company/courses/' + company_id + '/' + dropDate)
            .then((response) => response.json())
            .then((courses) => {
                dispatch({
                    type: GET_SCHEDULED_COURSES,
                    payload: courses
                })
            })
    }
}


export function getCompanyData(company_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getCompany(company_id)),
            dispatch(getAllMajors()),
            dispatch(getAllCourses(company_id)),
            dispatch(getLessonList()),
            dispatch(getAllModules()),
            dispatch(getRelatedData(company_id)),
            dispatch(getEvents(company_id, new Date())),
            dispatch(getScheduledCourses(company_id, new Date()))
        ]).then(
            () => dispatch(updateCompanyLoaded(true))
        )
    }
}

export function getCompanyList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((companyList) => {
                dispatch({
                    type: GET_COMPANY_LIST,
                    payload: companyList,
                });
            });
    }
}

export function deleteCompany(company_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_id: company_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_COMPANY,
                    payload: company_id,
                });
            });
    }
}

export function getRelatedData(company_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/company/data/' + company_id)
            .then((response) => response.json())
            .then((relatedData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: relatedData
                })
            })
    }
}

export function toggleInstructor(instructor, action_type) {
    return {
        type: TOGGLE_INSTRUCTOR,
        payload: { instructor: instructor, action_type: action_type }
    }
}

// COMPANY -> Major
export function getAllMajors() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return async (dispatch, getState) => {
        await fetch(server_connection + '/major/list/' + auth_id)
            .then((response) => response.json())
            .then((allMajors) => {
                dispatch({
                    type: GET_ALL_MAJORS,
                    payload: allMajors
                })
            })
    }
}

export function getAllCourses(company_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/company/course_list/' + company_id)
            .then((response) => response.json())
            .then((allCourses) => {
                dispatch({
                    type: GET_ALL_COURSES,
                    payload: allCourses
                })
            })
    }
}

function getAllModules() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/module/list/' + auth_id)
            .then((response) => response.json())
            .then((allModules) => {
                return dispatch({
                    type: GET_ALL_MODULES,
                    payload: allModules
                })
            })
    }
}

export function getCompanyAuthList(company_id) {
    return (dispatch) => {
        return fetch(server_connection + '/company/' + company_id + '/auth/list')
            .then((response) => response.json())
            .then((data) => {
                return dispatch({
                    type: GET_COMPANY_AUTH_LIST,
                    payload: data
                })
            })
    }
}

export function toggleMajor(major, action_type) {
    return {
        type: TOGGLE_MAJOR,
        payload: { major: major, action_type: action_type }
    }
}


// WEBPACK FOOTER //
// src/main/content/company/store/actions/company.actions.js